import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { resources } from './translations';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector) // detect user language
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

/**
 * Håller <html lang> i synk med det aktiva språket.
 *
 * index.html sätter lang="sv" (appens förstaspråk) som utgångsläge, men dokumentet
 * måste följa användarens val: annars läser skärmläsare svensk text med engelskt
 * uttal, eller tvärtom (WCAG 3.1.1 Language of Page). Endast språkkoden används,
 * inte regionen -- 'sv-SE' blir 'sv', vilket är vad resurserna är nycklade på.
 */
const syncDocumentLanguage = (language: string) => {
  if (typeof document === 'undefined') return;
  const code = language.split('-')[0];
  if (code) document.documentElement.lang = code;
};

syncDocumentLanguage(i18n.language ?? 'sv');
i18n.on('languageChanged', syncDocumentLanguage);

export default i18n;
